export const ACCENTS = {
  aqua: { hex: "#0FFFE2", text: "#000000", soft: "rgba(15,255,226,0.14)" },
  berry: { hex: "#DF1283", text: "#FFFFFF", soft: "rgba(223,18,131,0.10)" },
  lime: { hex: "#D0FF0D", text: "#000000", soft: "rgba(208,255,13,0.18)" },
  grape: { hex: "#4A0A66", text: "#FFFFFF", soft: "rgba(74,10,102,0.10)" },
  pumpkin: { hex: "#FC861E", text: "#FFFFFF", soft: "rgba(252,134,30,0.12)" },
};

export const ACCENT_KEYS = Object.keys(ACCENTS);

export const accentByIndex = (i) => ACCENTS[ACCENT_KEYS[i % ACCENT_KEYS.length]];
export const accentFor = (key) => ACCENTS[key] || ACCENTS.aqua;

export const BRAND_PINK = "#DF1283";
export const LOGO_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_ad-lookbook/artifacts/elhq3lsg_UnCloned%C2%AE%20Logo-Pink.png";
